module.exports = __webpack_public_path__ + "17c7f1a22531f3ee4e3a26ed7f1ef054.svg";